// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6c4b553","455":"77547771","977":"dd980091"}[chunkId] + ".chunk.js";
};